export const EpostFormFieldsColorOptionValue = {
  BlackAndWhite: 'black_and_white',
  Color: 'color',
}

export const EpostFormFieldsPrintSideOptionValue = {
  Double: 'double',
  Single: 'single',
}

export const EpostFormFieldsC4EnvelopeOptionValue = {
  No: false,
  Yes: true,
}

export const EpostFormFieldsRegisteredLetterOptionValue = {
  No: null,
  RegMail: 'REGMAIL',
  RegMailDrop: 'REGMAIL_DROP',
  RegMailInternational: 'REGMAIL_INTERNATIONAL',
}

export const EPOST_FORM_FIELDS_NAME_PROVIDER = 'vendor'

export const EPOST_FORM_FIELDS_NAME_LETTERS = 'letters'

export const EPOST_FORM_FIELDS_NAME_PAGES_COUNT = 'pages_count'

export const EPOST_FORM_FIELDS_NAME_COLOR = 'color'

export const EPOST_FORM_FIELDS_NAME_PRINT_SIDE = 'print_side'

export const EPOST_FORM_FIELDS_NAME_C4_ENVELOPE = 'c4_envelope'

export const EPOST_FORM_FIELDS_NAME_REGISTERED_LETTER = 'registered_letter'
